import { Line } from '@antv/g2plot';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { data } from './hardcoded';
import { renderTooltip } from '../../../../helpers/Tooltip';

const itemsConfig = [
  { color: '#6AD99E', key: 'targetedLevelOfPerformance', label: 'Targeted level of performance' },
  { color: '#6C737F', key: 'baselineESGPerformance', label: 'Baseline ESG performance' },
  { color: '#2E90FA', key: 'currentPerformance', label: 'Current performance ' }
];

const fill = itemsConfig.map((c) => c.color);

export default function useEsgPerformance({ container }) {
  const [mainGraph, setMainGraph] = useState(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (container.current) {
      const customContent = (title, data) => {
        if (Array.isArray(data) && data[0]) {
          return renderTooltip({
            title: t(title),
            items: data.map((d) => {
              const itemConfig = itemsConfig.find((c) => c.key === d.name);
              return { label: t(itemConfig?.label || ''), color: itemConfig?.color, value: d.data?.value || 0 }
            })
          });
        }

        return '';
      };

      if (mainGraph) {
        mainGraph.update({
          data: data,
          tooltip: { customContent },
          yAxis: {
            tickMethod: () => [1, 2, 3, 4, 5], // TODO: this should be only wehn empty
          },
        });
      } else {
        const area = new Line(container.current, {
          height: 372,
          data: data,
          xField: 'item',
          localRefresh: true,
          animation: false,
          yField: 'value',
          seriesField: 'type',
          point: {
            shape: 'round',
            size: 3,
          },
          xAxis: {
            nice: true,
          },
          yAxis: {
            tickMethod: () => [1, 2, 3, 4, 5], // TODO: this should be only wehn empty
          },
          legend: false,
          color: fill,
          tooltip: {
            shared: true,
            customContent,
          },
        });
        area.render();
        setMainGraph(area);
      }
    }
  }, [container, t]);
}
